/* @jsxImportSource @emotion/react */
import React from 'react'
import classNames from 'classnames'

import { fontSize } from './constants'

const buttonCss = {
  padding: '10px 20px',
  borderRadius: 999,
  fontSize: fontSize.small,
  transition: 'opacity .2s cubic-bezier(.215,.61,.355,1)',
  '&:hover': { opacity: 0.85, color: 'var(--shade-100)' },
  '&:hover .article-cta-chevron': { transform: 'translateX(2px)' },
} as const

const chevronCss = {
  transition: 'transform .2s cubic-bezier(.215,.61,.355,1)',
} as const

export function ArticleCtaButton(props: {
  label: string
  href: string
  fullWidth?: boolean
  'data-test-id'?: string
}) {
  return (
    <a
      href={props.href}
      data-test-id={props['data-test-id']}
      className={classNames(
        'flexbox-inline flexbox-align-center flexbox-gap-8 background-shade-00 shade-100 font-weight-semibold nowrap',
        props.fullWidth && 'width-full flexbox-justify-center'
      )}
      css={buttonCss}
    >
      {props.label}
      <svg
        className="article-cta-chevron"
        css={chevronCss}
        width="7"
        height="10"
        viewBox="0 0 7 10"
        fill="none"
        aria-hidden="true"
      >
        <path
          d="M1.5 1L5.5 5L1.5 9"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </a>
  )
}
